import React from "react";
import { Modal } from "@mui/material";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import Calendar from "../../../components/Dates/Calendar";
import spinner from "../../../assets/images/spinner.gif";

const AttendanceCalendarModal = ({
  showDates,
  setShowDates,
  isLoading,
  currentDatesSection,
  attendanceDates,
  monthDateObject,
}) => {
  return (
    <Modal
      open={showDates}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
    >
      <div className="document-wrapper px-6 divide-y bg-white h-max max-h-[80%] w-[40rem] ml-[30%] mt-[5%] overflow-auto">
        {isLoading ? (
          <div className="w-16 h-16 mx-auto mt-8">
            <img src={spinner} alt="spinner" className="w-full h-full" />
          </div>
        ) : (
          <>
            <div className="document-head py-4">
              <div className="flex items-center">
                <div
                  className="w-5 h-5 cursor-pointer mr-3"
                  onClick={() => setShowDates(false)}
                >
                  <ArrowLeftIcon className="text-black w-full h-full" />
                </div>
                <h3 className="text-gray-700 text-2xl font-semibold">
                  Calender
                </h3>
              </div>
            </div>
            <div className="pt-2 pb-4 overflow-auto">
              {currentDatesSection === "present" && (
                <>
                  <div className="flex flex-row flex-wrap mb-4 justify-between">
                    <div className="flex mt-4 flex-row mr-6 items-center">
                      <p className="px-2 py-2 rounded flex items-center justify-center bg-[color:var(--color1)] text-white text-center uppercase font-semibold text-sm"></p>
                      <p className="ml-2 text-sm">Present</p>
                    </div>
                    <div className="flex mt-4 flex-row mr-6 items-center">
                      <p className="px-2 py-2 bg-[color:var(--color13)] rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                      <p className="ml-2 text-sm">Absent</p>
                    </div>
                    <div className="flex mt-4 flex-row mr-6 items-center">
                      <p className="px-2 py-2 bg-[color:var(--color8)] rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                      <p className="ml-2 text-sm">Public Holidays</p>
                    </div>
                    <div className="flex mt-4 flex-row mr-6 items-center">
                      <p className="px-2 py-2 bg-[color:var(--color14)] rounded flex items-center justify-center text-white text-center uppercase font-semibold text-sm"></p>
                      <p className="ml-2 text-sm">Data pending</p>
                    </div>
                    <div className="flex mt-4 flex-row mr-6 items-center">
                      <p className="px-2 py-2 bg-indigo-600 rounded flex items-center justify-center bg-[color:var(--color1)] text-white text-center uppercase font-semibold text-sm"></p>
                      <p className="ml-2 text-sm">Approved Leaves</p>
                    </div>
                  </div>
                  <Calendar
                    attendanceDates={attendanceDates}
                    monthDateObject={monthDateObject}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default AttendanceCalendarModal;
